module.exports = __webpack_public_path__ + "img/vip_sign_5.0c02c217.png";